export default {
  header: {
    title: "Welcome to GenIaC",
    subtitle: "Create, manage and deploy your cloud architectures in just a few clicks"
  },
  setup: {
    title: "Quick setup",
    progress: "Configuration",
    allDone: "Everything is configured!",
    project: {
      label: "First project created",
      sublabel: "Create a project to organize your architectures",
      action: "Create a project"
    },
    connection: {
      label: "Cloud connection configured",
      sublabel: "Connect Azure, AWS, GCP or Fabric",
      action: "Configure"
    },
    devops: {
      label: "Azure DevOps configured",
      sublabel: "CI/CD pipeline for your Terraform deployments",
      action: "Configure"
    },
    execution: {
      label: "First execution launched",
      sublabel: "Plan or apply your first architecture",
      action: "Launch"
    }
  },
  steps: {
    stepLabel: "Step",
    step1: {
      title: "Create your first project",
      description: "Organize your cloud architectures by projects, like workspaces. Each project can contain multiple architectures.",
      action: "Create a project"
    },
    step2: {
      title: "Add and prepare your architectures",
      description: "In each project, create custom architectures with our drag & drop visual editor.",
      action: "View projects"
    },
    step3: {
      title: "Generate a predefined architecture",
      description: "Use our architecture templates to get started quickly: 3-tier, microservices, serverless, and more.",
      action: "Explore templates"
    },
    step4: {
      title: "Configure your cloud connections",
      description: "Connect your Azure, AWS or GCP accounts and configure Azure DevOps to enable Terraform deployments.",
      action: "Configure"
    }
  },
  features: {
    title: "And many more features...",
    list: {
      projectManagement: "Project and architecture management",
      visualEditor: "Drag & drop visual editor",
      templates: "Predefined templates",
      multiCloud: "Multi-cloud support (Azure, AWS, GCP)",
      exportImport: "Configuration export and import",
      collaboration: "Team collaboration"
    }
  },
  cta: {
    button: "Start now"
  }
};
